exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_preview_3BpmxF5Mp3pH2kVh-wbHf3 {\n  width: 100%;\n  height: calc(100% - 40px);\n  float: left;\n  clear: both;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n", ""]);

// Exports
exports.locals = {
	"IA_preview": "IA_preview_3BpmxF5Mp3pH2kVh-wbHf3"
};